export function ProvinceData() {
    return [
  {
    "count": 2,
    "provinceId": "511462"
  },
  {
    "count": 5,
    "provinceId": "690094"
  },
  {
    "count": 1,
    "provinceId": "367395"
  },
  {
    "count": 42,
    "provinceId": "285860"
  },
  {
    "count": 1,
    "provinceId": "646578"
  },
  {
    "count": 65,
    "provinceId": "244377"
  },
  {
    "count": 75,
    "provinceId": "483250"
  },
  {
    "count": 2,
    "provinceId": "115224"
  },
  {
    "count": 95,
    "provinceId": "545532"
  },
  {
    "count": 120,
    "provinceId": "604131"
  },
  {
    "count": 150,
    "provinceId": "624372"
  },
  {
    "count": 110,
    "provinceId": "646578"
  },
  {
    "count": 80,
    "provinceId": "533328"
  },
  {
    "count": 48,
    "provinceId": "191019"
  },
  {
    "count": 3,
    "provinceId": "624372"
  },
  {
    "count": 4,
    "provinceId": "452123"
  },
  {
    "count": 55,
    "provinceId": "452123"
  }
]


}